import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import zhLocale from "./config/zh";
import jaLocale from "./config/ja";
import enLocale from "./config/en";

let defaultLang = "en"
// 获取浏览器语言为默认语言
let jsSrc = (navigator.language || navigator.browserLanguage).toLowerCase();
if (jsSrc.indexOf("zh") != -1) {
  defaultLang = "zh"
} else if (jsSrc.indexOf("ja") != -1) {
  defaultLang = "ja"
} else {
  defaultLang = "en"
}

const i18n = new VueI18n({
  // 设置默认语言
  locale: defaultLang,
  messages: {
    zh: zhLocale,
    ja: jaLocale,
    en: enLocale,
  },
});

export default i18n;
